import * as dayjs from "dayjs";
import {PlayerMix} from "./player-mix.model";
import {PlayerHost} from "./host.model";
import {PlayerUserMix} from "./user-mix.model";
import {PlayerProgram} from "./program.model";
import { PlayerBrandedTag } from './branded-tag.model';
import { Expose, Transform, Type } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';

/**
 * Player Station
 * A readonly station model that is return by the player API.
 * This is the current station, along with all the associated hosts/programs/mixes
 */
export class PlayerStation {
  @Expose({name:'uid'})
  uid: string | undefined = undefined;
  @Expose({name:'station_code'})
  stationCode: string | undefined = undefined;
  @Expose({name:'created_at'})
  @Transform(dayjsTransformer, { toClassOnly: true })
  createdAt: dayjs.Dayjs | undefined = undefined;
  @Expose({name:'status'})
  status = 100;

  @Expose({name:'name'})
  name: string | undefined = undefined;
  @Expose({name:'description'})
  description: string | undefined = undefined;
  @Expose({name:'tag_line'})
  tagLine: string | undefined = undefined;
  @Expose({name:'timezone'})
  timezone: string | undefined = undefined;

  @Expose({name:'access_mode'})
  accessMode = 1;

  @Expose({name:'hosts'})
  @Type(() => PlayerHost)
  _hosts: PlayerHost [] = [];
  @Expose({name:'mixes'})
  @Type(() =>PlayerMix)
  _mixes: PlayerMix [] = [];
  @Expose({name:'featured_mixes'})
  @Type(() =>PlayerMix)
  _featuredMixes: PlayerMix [] = [];
  @Expose({name:'recent_mixes'})
  @Type(() =>PlayerMix)
  _recentMixes: PlayerMix [] = [];
  @Expose({name:'genres'})
  @Type(() =>PlayerMix)
  _genres: PlayerMix [] = [];
  @Expose({name:'mix_categories'})
  @Type(() =>PlayerBrandedTag)
  _mixCategories: PlayerBrandedTag [] = [];

  @Expose({name:'user_mixes'})
  @Type(() =>PlayerUserMix)
  _userMixes: PlayerUserMix [] = [];
  @Expose({name:'programs'})
  @Type(() =>PlayerProgram)
  _programs: PlayerProgram [] = [];
}
